//@ts-nocheck
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import useHot from './useHot';
import PCScroller from './PCScroller';
import useTheme from '../hooks/useTheme';
import { style } from '../../utils/image';
import { getScrollCls } from '../../utils/util';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import { IComponentHot, IComponentHotOne } from '../../component';
import { CloseAnimation } from '../GalleryList/GalleryListWrapper';

import '../common.scss';
import './AllForHot.scss';

// 解析查看更多的跳转链接，返回完整 href
function getShowMoreLink(props: IComponentHot): string | null {
  const { showMore, showMoreType, showMoreUrl, showMorePage } = props;
  if (!showMore) return null;
  if (showMoreType === 'none') return null;
  if (showMoreType === 'url' && showMoreUrl) return showMoreUrl;
  // page 模式：showMorePage 是 link_id，需要拼接 /g/ 前缀
  if (showMoreType === 'page' && showMorePage) return '/g/' + showMorePage;
  return null;
}

export default function AllForHot(props: IComponentHot) {
  const { template, title, hot_list, showMore } = props;
  const { mainColor } = useTheme();
  const { setBigIndex, borderColor, h1Color, bigIndex, bigList, displayList } =
    useHot(props);
  const [simpleBigIndex, setSimpleBigIndex] = useState(-1);
  const prevBigIndexRef = useRef(-1);
  const openTimerRef = useRef<number | null>(null);

  useEffect(() => {
    const prevBigIndex = prevBigIndexRef.current;

    // 首次打开：等待 CloseAnimation 的打开动画结束后再显示大图，避免双层同时出现
    if (prevBigIndex === -1 && bigIndex > -1) {
      if (openTimerRef.current) {
        window.clearTimeout(openTimerRef.current);
      }
      openTimerRef.current = window.setTimeout(() => {
        setSimpleBigIndex(bigIndex);
      }, 350);
    }
    // 已在大图内切换上一张/下一张：立即同步
    else if (prevBigIndex > -1 && bigIndex > -1) {
      setSimpleBigIndex(bigIndex);
    }
    // 关闭：立即隐藏大图，让关闭动画单独播放
    else if (bigIndex === -1) {
      if (openTimerRef.current) {
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
      }
      setSimpleBigIndex(-1);
    }

    prevBigIndexRef.current = bigIndex;
  }, [bigIndex]);

  useEffect(() => {
    return () => {
      if (openTimerRef.current) {
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
      }
    };
  }, []);

  const showMoreLink = getShowMoreLink(props);

  const renderVerticalImage = function (img: string, index: number) {
    return (
      <div
        className="list-one"
        data-hot-pic-item-index={index}
        onClick={() => setBigIndex(index)}
        key={index}
      >
        <img src={style(img, 'wx_250_350')} className={'one-photo vertical'} />
      </div>
    );
  };

  const renderHorizontalImage = function (img: string, index: number) {
    return (
      <div
        className="list-one"
        data-hot-pic-item-index={index}
        onClick={() => setBigIndex(index)}
        key={index}
      >
        <img
          src={style(img, 'wx_555_350')}
          className={'one-photo horizontal'}
        />
      </div>
    );
  };

  // list的模式下，没法显示desc
  const renderTemplate1 = function (list: IComponentHotOne[]) {
    if (!list || !list.length) {
      return;
    }
    // 一张
    const len = list.length;
    const imgList: any[] = [];
    const firstImg = list[0].image;
    const lastImg = list[len - 1].image;
    if (len === 1) {
      imgList.push(renderVerticalImage(firstImg, 0));
    } else if (len === 2) {
      list.forEach((one, index) => {
        imgList.push(renderVerticalImage(one.image, index));
      });
    } else {
      // >=3
      imgList.push(renderVerticalImage(firstImg, 0));
      const centerList = list.slice(1, -1);
      centerList.forEach((one, index) => {
        imgList.push(renderHorizontalImage(one.image, index + 1));
      });
      // 最后一个
      imgList.push(renderVerticalImage(lastImg, len - 1));
    }
    // 图片张数>=4时平均分2行显示
    if (len >= 4) {
      const half = Math.ceil(len / 2); //取天花板，第一行可以比第二行多1个
      return (
        <div className={classNames('hot-list template1', getScrollCls())}>
          <div className="row row1">{imgList.slice(0, half)}</div>
          <div className="row row2">{imgList.slice(half)}</div>
        </div>
      );
    }
    return (
      <div
        className={classNames('hot-list template1', getScrollCls())}
        style={{ display: 'flex' }}
      >
        {imgList}
      </div>
    );
  };

  // 右箭头 SVG（与后台 Icon type="right" 对齐）
  const ArrowRight = () => (
    <span style={{marginLeft: 4, display: 'inline-flex', alignItems: 'center'}}>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      version="1.1"
      width="10"
      height="8"
      viewBox="0 0 10 8"
    >
      <path
        d="M7.5233326,3.3333335L5.333333,0.99133348L6.2599993,0L10,4L6.2600002,8L5.333333,7.008667L7.5233326,4.666667L0,4.666667L0,3.3333335L7.5233326,3.3333335Z"
        fill={mainColor || '#24d9cd'}
        fillOpacity="1"
        style={{ mixBlendMode: 'passthrough' }}
      />
    </svg>
    </span>  
  );

  // 渲染查看更多链接
  const renderShowMore = () => {
    if (!showMore) return null;

    if (showMoreLink && showMoreLink.startsWith('http')) {
      return (
        <a
          href={showMoreLink}
          target="_blank"
          rel="noopener noreferrer"
          className="hot-show-more-btn"
          style={{ borderColor: mainColor, color: mainColor }}
        >
          <span>查看更多</span>
          <ArrowRight />
        </a>
      );
    }

    if (showMoreLink) {
      // 内部页面跳转：使用 window.location.href 确保 SPA 整页刷新到目标路由
      return (
        <span
          className="hot-show-more-btn"
          style={{ borderColor: mainColor, color: mainColor }}
          onClick={() => {
            window.location.href = showMoreLink;
          }}
        >
          <span>查看更多</span>
          <ArrowRight />
        </span>
      );
    }

    return (
      <span
        className="hot-show-more-btn"
        style={{ borderColor: mainColor, color: mainColor }}
      >
        <span>查看更多</span>
        <ArrowRight />
      </span>
    );
  };

  // 使用 displayList（支持手动和相册两种来源）
  const renderList = displayList || hot_list || [];
  const animationList = renderList.map((item, index) => ({
    ...item,
    __hotIndex: index,
  }));

  return (
    <div className={'all-for-hot hot-pic-component decoratev2-comp-com'}>
      <div className="row-wrapper" style={{ color: h1Color }}>
        {title && (
          <p
            className="title"
            style={{ color: h1Color, width: 'auto', margin: 0 }}
          >
            {title}
          </p>
        )}
        <PCScroller>
          {template === 'template1' ? (
            renderTemplate1(renderList)
          ) : (
            <div className={classNames('hot-list', getScrollCls(), template)}>
              {renderList.map((one, index) => (
                <div
                  className={'list-one'}
                  data-hot-pic-item-index={index}
                  key={index}
                  onClick={() => {
                    setBigIndex(index);
                  }}
                >
                  <img
                    src={style(one.image, 'wx_375_375_square')}
                    className={'one-photo'}
                    style={{ border: `1px solid ${borderColor}` }}
                  />
                  <div className={'one-name'}>{one.desc}</div>
                </div>
              ))}
            </div>
          )}
        </PCScroller>
        {showMore ? (
          <div className="hot-show-more-wrap">{renderShowMore()}</div>
        ) : null}
      </div>
      <SimpleBigPic
        pageType="HotList"
        index={simpleBigIndex}
        list={bigList}
        setIndex={setBigIndex}
        showDetail={true}
      />
      <CloseAnimation
        containerSelectorFunction={() => {
          return 'body';
        }}
        targetElementSelectorFunction={(item: any) => {
          return `[data-hot-pic-item-index="${item.__hotIndex}"]`;
        }}
        list={animationList}
        index={bigIndex}
      />
    </div>
  );
}
